const listeners = new Set<() => void>();

export const requestGroupCallExpand = (): void => {
    [...listeners].forEach(listener => listener());
};

export const onGroupCallExpandRequested = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
